import * as React from 'react';
import Linkify from 'react-linkify';
import MessageMeta from 'components/MessageMeta/MessageMeta';
import styles from './Message.css';
const whiteAnchorLinkText = '#fff';
const blueAnchorLinkText = '#2874f0';
export default class Message extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { isReceivedMessage, timeStamp, messageStatus, messageContent, showMessageMeta } = this.props;
        return (<div className={styles['message']}>
				<Linkify properties={{
            target: '_blank',
            style: { color: isReceivedMessage ? blueAnchorLinkText : whiteAnchorLinkText, textDecoration: 'underline' }
        }} className={styles['message-content']}>
					{messageContent}
				</Linkify>

				{showMessageMeta && (<MessageMeta lastReadMessageTimestamp={this.props.lastReadMessageTimestamp} lastDeliveredMessageTimestamp={this.props.lastDeliveredMessageTimestamp} isReceivedMessage={isReceivedMessage} timeStamp={timeStamp} messageStatus={messageStatus}/>)}
			</div>);
    }
}
Message.defaultProps = {
    showMessageMeta: true
};
